import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, RouterStateSnapshot } from '@angular/router';
import 'rxjs/add/operator/map';
import { AuthService } from 'shared/services/Auth/auth.service';
import { UserService } from 'shared/services/User/user.service';
import { GroupService } from 'shared/services/SS-Groups/groups.service';

@Injectable()
export class GroupsGuard implements CanActivate {

  constructor(
    private router: Router,
    private gs: GroupService
  ) { }
  // this call is activated for routes that cant be used unless all onboarding is complete
  canActivate(route, state: RouterStateSnapshot) {
    const a = route.queryParams;
    this.gs.refreshGroup(a.groupId).subscribe(res => {
    }, err => {
      this.router.navigate(['/error']);
    });
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/Guards/groups-guard.ts